import AirPlay from '@mui/icons-material/Airplay';
import IconeCalendario from '@mui/icons-material/CalendarMonth';
import FilterIcon from '@mui/icons-material/FilterListOutlined';
import FindInPage from '@mui/icons-material/FindInPage';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import MeetingRoom from '@mui/icons-material/MeetingRoom';
import NoMeetingRoom from '@mui/icons-material/NoMeetingRoom';
import PlayIcon from '@mui/icons-material/PlayCircleOutline';
import SnoozeIcon from '@mui/icons-material/Snooze';
import StopIcon from '@mui/icons-material/Stop';
import { Box, Checkbox, CircularProgress, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ApmVars from '@/util/ApmVars';
import Configuracao from '../util/Configuracao';
import SentryUtil from '@/util/SentryUtil';
import { ROTA } from '../dominio/Rota';
import PopoverSecretaria from './PopoverSecretaria';
import ReactComponent from './ReactComponent';

class ListaSessoes extends ReactComponent {
    openMenuSessoes = false;
    carregandoSessoesComPendencias = false;

    get exibirComboSessao() {
        return (
            !this.errorStore.hasError &&
            this.usuarioStore.isUsuarioLogado &&
            (this.routerStore.isSalaSessao || this.routerStore.isPautaJulgamento || this.routerStore.isPreSessao)
        );
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            openMenuSessoes: observable,
            carregandoSessoesComPendencias: observable,
            exibirComboSessao: computed,
            descricaoSessaoSelecionada: computed,
            handleCloseMenuSessoes: action,
            handleClickMenuSessoes: action,
            handleClickSessao: action,
            sessoesComPendencias: computed,
            sessoesJulgamento: computed,
            tooltipSessaoSelecionada: computed,
            abrirCalendario: action,
            carregarSessoesComPendencias: action,
            scrollSessaoEncerrada: action,
            exibirIconePendencias: computed,
            renderMenuSessoes: computed,
            renderPendencias: computed,
            renderCalendario: computed,
            renderPopover: computed,
            renderSessoes: computed
        });
    }

    get descricaoSessaoSelecionada() {
        if (this.sessaoStore.sessoesJulgamento && this.sessaoStore.idSessaoSelecionada !== -1) {
            let sessao = this.sessaoStore.sessoesJulgamento.find(
                (sessao) => sessao.id === this.sessaoStore.idSessaoSelecionada
            );

            if (sessao) {
                return this.getDescricaoOpcaoSessao(sessao);
            }
        }

        return '';
    }

    handleCloseMenuSessoes = () => {
        this.openMenuSessoes = false;
    };

    handleClickMenuSessoes = () => {
        this.openMenuSessoes = true;
    };

    handleClickSessao = (sessao) => {
        this.handleCloseMenuSessoes();
        if (sessao && sessao.id !== this.sessaoStore.idSessaoSelecionada) {
            ApmVars.setTagSessaoId(sessao.id);
            ApmVars.setTagNumeroProcesso('');
            SentryUtil.setScope();

            this.cancelarRequisicoesPendentes();
            this.salaSessaoStore.reset();
            this.pautaJulgamentoStore.reset();
            this.preSessaoStore.reset();
            this.sessaoStore.carregandoSessao = true;
            setTimeout(() => {
                runInAction(() => (this.sessaoStore.idSessaoSelecionada = sessao.id));
                this.sessaoStore.inicializarSessaoJulgamento();
                if (this.routerStore.isPautaJulgamento) {
                    this.pautaJulgamentoStore.inicializarPautaJulgamento();
                }
            }, 1);
        }
    };

    get sessoesComPendencias() {
        return this.sessaoStore.sessoesComPendencias;
    }

    get sessoesJulgamento() {
        return this.sessaoStore.sessoesJulgamento;
    }

    get tooltipSessaoSelecionada() {
        if (this.sessaoStore.idSessaoSelecionada !== -1) {
            return <div>Sessão: {this.descricaoSessaoSelecionada}</div>;
        }
        return <div>Selecionar uma sessão</div>;
    }

    abrirCalendario = () => {
        this.redirecionar(ROTA.CALENDARIO.rota);
    };

    carregarSessoesComPendencias = async () => {
        let sessaoEncerrada = this.sessoesJulgamento.find((sessao) => sessao.situacao === 'ENCERRADA');
        if (!this.carregandoSessoesComPendencias) {
            if (sessaoEncerrada) {
                try {
                    this.carregandoSessoesComPendencias = true;
                    this.openMenuSessoes = true;
                    setTimeout(() => this.scrollSessaoEncerrada(sessaoEncerrada), 20);
                    await this.sessaoStore.carregarSessoesComPendencias();
                } finally {
                    runInAction(() => (this.carregandoSessoesComPendencias = false));
                }
            }
        } else {
            this.mensagemStore.abrirMensagemInfo('Favor aguardar o carregamento das pendências');
            setTimeout(() => runInAction(() => (this.openMenuSessoes = true)), 20);
            setTimeout(() => this.scrollSessaoEncerrada(sessaoEncerrada), 40);
        }
    };

    scrollSessaoEncerrada(sessaoEncerrada) {
        let elemento = document.getElementById(`MI-${sessaoEncerrada.id}`);
        if (elemento) {
            let index = this.sessoesJulgamento.findIndex((sessao) => sessao.situacao === 'ENCERRADA');
            let container = document.getElementById('divPopoverSessoes');

            if (container !== null) {
                container.scrollTop = index * elemento.clientHeight - 200;
            }
        }
    }

    get exibirIconePendencias() {
        return (
            this.sessoesJulgamento &&
            this.sessoesJulgamento.findIndex((sessao) => sessao.situacao === 'ENCERRADA') !== -1
        );
    }

    render() {
        if (!this.exibirComboSessao) {
            return null;
        }

        return (
            <>
                {this.renderMenuSessoes}
                <div style={{ display: 'flex' }}>
                    <Tooltip
                        title={
                            <Typography>
                                {this.sessaoStore.exibirTodasAsSessoes
                                    ? 'Ocultar sessões sem processos'
                                    : 'Exibir sessões sem processos'}
                            </Typography>
                        }
                        style={{ padding: '6px' }}
                    >
                        <Checkbox
                            checked={this.sessaoStore.exibirTodasAsSessoes}
                            onChange={this.sessaoStore.toggleExibirTodasAsSessoes}
                            icon={<FilterIcon style={{ color: red[500] }} />}
                            checkedIcon={<FilterIcon style={{ color: 'white', opacity: '0.7' }} />}
                        />
                    </Tooltip>
                    <Tooltip
                        title={
                            <Typography>
                                {this.sessaoStore.exibirSessoesPassadas
                                    ? 'Ocultar sessões passadas'
                                    : 'Exibir sessões passadas'}
                            </Typography>
                        }
                        style={{ padding: '6px' }}
                    >
                        <Checkbox
                            checked={this.sessaoStore.exibirSessoesPassadas}
                            onChange={this.sessaoStore.toggleExibirSessoesPassadas}
                            icon={<HistoryToggleOffIcon style={{ color: red[500] }} />}
                            checkedIcon={<HistoryToggleOffIcon style={{ color: 'white', opacity: '0.7' }} />}
                        />
                    </Tooltip>
                </div>
                {this.renderPendencias}
                {this.renderCalendario}
                {this.renderPopover}
            </>
        );
    }

    get renderMenuSessoes() {
        return (
            <Tooltip title={this.tooltipSessaoSelecionada}>
                <Box
                    id="menuSessoes"
                    onClick={this.handleClickMenuSessoes}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        borderColor: 'white',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        height: '30px',
                        paddingRight: '4px'
                    }}
                >
                    <Typography
                        variant="h5"
                        component="h5"
                        color="inherit"
                        style={{
                            fontSize: '1em',
                            fontWeight: 'normal',
                            margin: '0px 8px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '400px'
                        }}
                    >
                        {(this.sessaoStore.carregandoSessoes && 'Carregando sessões...') ||
                            this.descricaoSessaoSelecionada ||
                            'Selecione uma sessão...'}
                    </Typography>
                    <KeyboardArrowDown style={{ fill: 'white' }} />
                </Box>
            </Tooltip>
        );
    }

    get renderPendencias() {
        return (
            this.exibirIconePendencias && (
                <Tooltip title={'Verificar pendências das sessões encerradas'}>
                    <IconButton
                        onClick={this.carregarSessoesComPendencias}
                        color="inherit"
                        style={{ width: '40px' }}
                        size="large"
                    >
                        <FindInPage />
                    </IconButton>
                </Tooltip>
            )
        );
    }

    get renderCalendario() {
        if (!this.isComponenteHabilitado('Calendario')) {
            return null;
        }

        return (
            <IconButton
                onClick={this.abrirCalendario}
                color="inherit"
                style={{ width: '40px' }}
                size="large"
            >
                <Tooltip title={<Typography>Calendário de pautas/sessões</Typography>}>
                    <IconeCalendario />
                </Tooltip>
            </IconButton>
        );
    }

    get renderPopover() {
        return (
            <PopoverSecretaria
                open={this.openMenuSessoes}
                onClose={this.handleCloseMenuSessoes}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                elevation={12}
                anchorEl={() => document.getElementById('menuSessoes')}
                style={{ padding: '0px' }}
            >
                <div
                    id="divPopoverSessoes"
                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                >
                    {this.renderSessoes}
                </div>
            </PopoverSecretaria>
        );
    }

    get renderSessoes() {
        if (
            !this.sessaoStore.sessoesJulgamentoFiltradasOrdenadas ||
            this.sessaoStore.sessoesJulgamentoFiltradasOrdenadas.length === 0
        ) {
            return <Typography>Não há sessões que se enquadrem aos critérios dos filtros aplicados.</Typography>;
        }

        return this.sessaoStore.sessoesJulgamentoFiltradasOrdenadas.map((sessao) => (
            <div
                id={`MI-${sessao.id}`}
                key={`MI-${sessao.id}`}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '60px' }}
            >
                <MenuItem
                    style={{ width: '100%', height: '60px' }}
                    key={`MI-${sessao.id}-conteudo`}
                    value={sessao.id}
                    onClick={() => this.handleClickSessao(sessao)}
                >
                    {this.renderConteudoItemMenuSessao(sessao)}
                </MenuItem>
            </div>
        ));
    }

    renderConteudoItemMenuSessao(sessao) {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <Tooltip title={this.getDescricaoOpcaoSessao(sessao)}>
                    <Typography
                        style={{
                            fontWeight: this.getDestaqueSessao(sessao),
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100ch'
                        }}
                    >
                        {this.getDescricaoOpcaoSessao(sessao)}
                    </Typography>
                </Tooltip>
                {this.renderIconeSituacaoSessao(sessao)}
            </div>
        );
    }

    renderIconeSituacaoSessao = (sessao) => {
        switch (sessao.situacao) {
            case Configuracao.STATUS_ABERTA:
            case Configuracao.STATUS_NAO_GERENCIADA_ABERTA:
                return (
                    <Tooltip
                        title="Aberta"
                        style={{ zIndex: '999999' }}
                        placement="right"
                    >
                        <MeetingRoom style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                    </Tooltip>
                );
            case Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO:
            case 'NAO_GERENCIADA_AGUARDANDO_SESSAO_JULGAMENTO':
                return (
                    <Tooltip
                        title="Aguardando Sessão de Julgamento"
                        style={{ zIndex: '999999' }}
                        placement="right"
                    >
                        <SnoozeIcon style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                    </Tooltip>
                );
            case Configuracao.STATUS_INICIADA:
            case 'NAO_GERENCIADA_INICIADA':
                return (
                    <Tooltip
                        title="Iniciada"
                        style={{ zIndex: '999999' }}
                        placement="right"
                    >
                        <PlayIcon style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                    </Tooltip>
                );
            case Configuracao.STATUS_ENCERRADA:
            case Configuracao.STATUS_NAO_GERENCIADA_ENCERRADA:
                return this.renderIconeEncerrada(sessao);
            case Configuracao.STATUS_FECHADA:
            case Configuracao.STATUS_NAO_GERENCIADA_FECHADA:
                return (
                    <Tooltip
                        title="Fechada"
                        style={{ zIndex: '999999' }}
                        placement="right"
                    >
                        <NoMeetingRoom style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                    </Tooltip>
                );
            case Configuracao.STATUS_PLENARIO_VIRTUAL:
            case Configuracao.STATUS_NAO_GERENCIADA_PLENARIO_VIRTUAL:
                return (
                    <Tooltip
                        title="Plenário Virtual"
                        style={{ zIndex: '999999' }}
                        placement="right"
                    >
                        <AirPlay style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    renderIconeEncerrada(sessao) {
        return (
            <div style={{ display: 'flex' }}>
                {this.carregandoSessoesComPendencias ? (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                        <Tooltip
                            title="Carregando pendências das sessões encerradas"
                            style={{ zIndex: '999999' }}
                            placement="top"
                        >
                            <CircularProgress size={20} />
                        </Tooltip>
                    </div>
                ) : (
                    sessao?.id !== undefined &&
                    this.sessoesComPendencias &&
                    this.sessoesComPendencias[sessao.id] && (
                        <Tooltip
                            title="Existem Pendências"
                            style={{ zIndex: '999999' }}
                            placement="top"
                        >
                            <FindInPage style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                        </Tooltip>
                    )
                )}
                <Tooltip
                    title="Encerrada"
                    style={{ zIndex: '999999' }}
                    placement="right"
                >
                    <StopIcon style={{ verticalAlign: 'middle', marginLeft: '10px' }} />
                </Tooltip>
            </div>
        );
    }
}

export default inject('stores')(observer(ListaSessoes));
